export default {
    WHATS_APP_SEND: () => `/whatsapp/sendMessage`,
    GET_WHATSAPP_MESSAGE: () => `/whatsapp/getAllChatByContactNo/120363403491434219@g.us`,
    WHATSAPP_getTaskBy: (id) => `/task/getTaskBy/${id}`,
    GET_CONTACT_WHATSAPP: (data) => `/whatsapp/getAllContact?flag=${data}`,
    GET_CHAT_BYID_WHATSAPP: (id) => `/whatsapp/getAllContactByContactId/${id}`,
    CLIENT_GENERATE: () => `/whatsapp/qr`,
    CLIENT_GENERATE_QRCODE: (id) => `/whatsapp/whatsappbyClientId/${id}`,
    GET_ALL_CLIENT: () => `/whatsapp/getWtProfile`,
    Travel_Contact: () => `/travellerDetails`,
    GET_ALL_WHATSAPP_CHAT: () => '/socket',
    GET_BYID_WHATSAPP_PROFILE: (id) => `/whatsapp/getProfileByProfileId/${id}`,
    GET_BY_GROUP_ID_WHATSAPP_PROFILE: (id) => `/whatsapp/getProfileByProfileId/${id}?flag=true`,
    GET_All_PROFILE_FOR_WHATSAPP: () => `/whatsapp/getAllProfile`,
    ADD_CONTACT: () => `/whatsapp/sendAttachment`,
    ADD_GROUP: () => `/whatsapp/addGroup`,
    ADD_WHATSAAP_ATTACHMENT: () => `/whatsapp/sendAttachment`,
    GET_ALL_ATTACHMENT: (id) => `/email/getAllAttachment/${id}`,
    DELETE_WHATSAPP_CLIENT: (id) => `/whatsapp/updateProfiles/${id}`,
    UPDATE_STATUS:(id) => `/whatsapp/updateByContactId/${id}`
};
